import type { Pagination } from 'models';
import { generateQueryKey } from 'query';
import type { GroupUsersFilter, GroupsListFilter } from '../models';

type GroupsParams = {
  filter?: GroupsListFilter;
  pagination?: Partial<Pagination>;
};

type GroupUsersParams = {
  filter?: Partial<GroupUsersFilter>;
  pagination?: Partial<Pagination>;
};

// TODO: split group
export const getGroupDetailQueryKey = ({ groupId }: { groupId: string }) =>
  generateQueryKey(['groups', 'detail', groupId]);

export const getGroupUsersInfiniteQueryKey = ({ filter, pagination }: GroupUsersParams) =>
  generateQueryKey(['groups', 'users', { filter, pagination }]);

export const getGroupsQueryKey = ({ filter = {}, pagination = {} }: GroupsParams) =>
  generateQueryKey(['groups', 'list', { filter, pagination }]);

export const getGroupsInfiniteQueryKey = ({ filter = {}, pagination = {} }: GroupsParams) =>
  generateQueryKey([...getGroupsQueryKey({ filter, pagination }), 'infinite']);
